import { atom } from 'jotai';

export const sessionSettingsMobileModalOpenAtom = atom(false);
